import { BREAKPOINTS } from "../ApplicationConfig";
import ApplicationState from "../ApplicationState";
import InlineMap from "../InlineMap";
import addResizeHandler from "../ResizeEventListener";

export default function initContactsPage()
{
    const CLASS_ACTIVE = 'contacts__tab_active';

    let initialWidth   = document.documentElement.clientWidth;
    let mobileMap      = new InlineMap('', '#js-contacts-mobile-map');
    let desktopMap     = new InlineMap('', '#js-contacts-desktop-map');
    let mapsController = new MapsController;

    if (mobileMap.getWrapperNode() === null || desktopMap.getWrapperNode() === null) {
        // не та страница, пропускаем функционал
        return;
    }
    
    mobileMap.setSrc(mobileMap.getWrapperNode().getAttribute('data-initial-src'));
    desktopMap.setSrc(desktopMap.getWrapperNode().getAttribute('data-initial-src'));

    // клик по кнопкам на десктопе
    document.querySelectorAll('.js-switch-map-button').forEach(button => {
        button.addEventListener('click', () => {            
            let parent = button.parentElement;

            if (parent.classList.contains(CLASS_ACTIVE)) {
                return;
            }

            document.querySelectorAll('.contacts__tab').forEach(tab => {
                tab.classList.remove(CLASS_ACTIVE);
            });

            mapsController.refresh(desktopMap, parent.getAttribute('data-store-id'));
            parent.classList.add(CLASS_ACTIVE);
        });
    });

    // резайзы
    addResizeHandler(() => {
        let currentWidth = document.documentElement.clientWidth;

        if (initialWidth >= BREAKPOINTS.XL && currentWidth < BREAKPOINTS.XL) {
            if (!mobileMap.getWrapperNode().classList.contains('_rendered')) {
                mobileMap.render();
                mobileMap.getWrapperNode().classList.add('_rendered');
            }

            mapsController.refresh(desktopMap, 'sklad_map');
        }

        if (initialWidth < BREAKPOINTS.XL && currentWidth >= BREAKPOINTS.XL) {
            let activeTab = document.querySelector('.' + CLASS_ACTIVE);
            mapsController.refresh(desktopMap, activeTab.getAttribute('data-store-id'));
        }

        initialWidth = currentWidth;
    });


    // инициализация
    let observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (document.documentElement.clientWidth < BREAKPOINTS.XL) {
                    mobileMap.render();
                    mobileMap.getWrapperNode().classList.add('_rendered');
                    mapsController.refresh(desktopMap, 'sklad_map');
                } else {
                    desktopMap.render();
                }

                observer.unobserve(mobileMap.getWrapperNode());
                observer.unobserve(desktopMap.getWrapperNode());
            }
        });
    });

    observer.observe(mobileMap.getWrapperNode());
    observer.observe(desktopMap.getWrapperNode());
}

class MapsController
{
    protected storage: any = {};

    public refresh(map: InlineMap, id: string)
    {
        map.clearWrapper();

        if (id in this.storage) {
            map.setSrc(this.storage[id]);
            map.render();
        } else {
            let xhr  = ApplicationState.axios;
            let data = new FormData;

            data.append('identifier', id);

            xhr.post('/page/view_map/', data).then(rsp => {
                let url = rsp.data.replace(/^[^]*src="([^"]+)"[^]*$/i, '$1');
                this.storage[id] = url;

                map.setSrc(url);
                map.render();
            });
        }
    }
}
